module.exports = __webpack_public_path__ + "img/32.9.TU.1468a770.png";